import { render, staticRenderFns } from "./CelulaDadosContatos.vue?vue&type=template&id=a3809a1a&"
import script from "./CelulaDadosContatos.vue?vue&type=script&lang=js&"
export * from "./CelulaDadosContatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports